import modelExtend from 'dva-model-extend';

import { NotificationStatus } from 'enums';
import { countUnreadNotification, getNotifications, getActivities, updateNotification, updateNotifications } from '../services/notification';
import { model } from './common';

export default modelExtend(model, {
  namespace: 'notification',

  state: {
    unreadNotificationCount: 0,
    notifications: null,
    hasMoreNotifications: true,
    notificationParams: {
      limit: 10,
      cursor: null,
    },

    activities: null,
    hasMoreActivities: true,
    activityParams: {
      limit: 10,
      cursor: null,
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      history.listen((location) => {
        if (location.pathname === '/activity') {
          dispatch({
            type: 'getActivities',
            payload: location.query,
          });
        }
      });
    },
  },

  effects: {
    * countUnreadNotification({ payload, output }, { call, put }) {
      const data = yield call(countUnreadNotification, payload);
      output && (output.value = data);
      if (data.success) {
        yield put({
          type: 'updateState',
          payload: {
            unreadNotificationCount: data.unread,
          },
        });
      } else {
        throw data;
      }
    },

    * getNotifications({ payload, output }, { call, put }) {
      const data = yield call(getNotifications, payload);
      output && (output.value = data);
      if (data.success) {
        yield put({
          type: 'updateState',
          payload: {
            notifications: data.notifications,
          },
        });
      } else {
        throw data;
      }
    },

    * getActivities({ payload, output }, { call, put }) {
      const params = { cursor: null, limit: 10, ...payload };
      const data = yield call(getActivities, params);
      output && (output.value = data);
      if (data.success) {
        yield put({
          type: 'getActivitiesSuccess',
          payload: {
            result: data.activities,
            params,
          },
        });
      } else {
        throw data;
      }
    },

    * loadMoreActivities(_, { select, put }) {
      const { activityParams, activities } = yield (select(({ notification }) => notification));
      let cursor = null;
      if (activities.length > 0) {
        cursor = activities[activities.length - 1].id;
      }
      yield put({ type: 'getActivities', payload: { ...activityParams, cursor } });
    },


    * updateNotification({ payload, output }, { call, put }) {
      const data = yield call(updateNotification, payload);
      output && (output.value = data);
      if (data.success) {
        yield put({
          type: 'updateNotificationSuccess',
          payload,
        });
      } else {
        throw data;
      }
    },

    * markAllAsRead({ output }, { call, put }) {
      const data = yield call(updateNotifications, { markAllAsRead: true });
      output && (output.value = data);
      if (data.success) {
        yield put({
          type: 'markAllAsReadSuccess',
        });
      } else {
        throw data;
      }
    },

  },

  reducers: {
    updateNotificationSuccess(state, { payload }) {
      let unreadNotificationCount = state.unreadNotificationCount;
      if (payload.status === 1) {
        // Mark as read
        unreadNotificationCount -= 1;
        if (unreadNotificationCount < 0) unreadNotificationCount = 0;
      }
      return {
        ...state,
        unreadNotificationCount,
        notifications: state.notifications.map((item) => {
          if (item.id !== payload.id) return item;
          return { ...item, ...payload };
        }),
      };
    },

    markAllAsReadSuccess(state) {
      return {
        ...state,
        unreadNotificationCount: 0,
        notifications: state.notifications.map((item) => {
          if (item.status === NotificationStatus.UNREAD) {
            return { ...item, status: NotificationStatus.READ };
          }
          return item;
        }),
      };
    },

    getActivitiesSuccess(state, { payload: { result, params } }) {
      let activities;
      if (params.cursor) {
        activities = [...state.activities, ...result];
      } else {
        activities = result;
      }
      return {
        ...state,
        activities,
        activityParams: params,
        hasMoreActivities: result.length >= params.limit,
      };
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/notification.js